/***********************  ADD PROJECT ****************************************/

import { CREATE_LEAD,CREATE_LEAD_ERR} from '../../actionTypes/leadsType'
import { createLeadApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'


export const createLead = payload => async dispatch => {
    try {
        let results = await axios.post(`${createLeadApi}`, payload, await accessToken())
         console.log("CREATE LEAD", results)
        let data = results && results.data
        dispatch({
            type: CREATE_LEAD,
            payload: data || [],
        });
    } catch (error) {
        dispatch({
            type: CREATE_LEAD_ERR,
            payload: error.response
        });
    }
}

/***********************  ADD PROJECT ****************************************/